import { createSelector } from 'reselect';
import { RootState } from '../../store';
import { IRegionWellWaterSystemResult, ICountyWellWaterSystemResult } from '../../../types';

const getRegionsHousingUnitsData = (state: RootState): IRegionWellWaterSystemResult[] => 
  state.wellWaterSystemAggregates.regionsHousingUnits || [];
const getCountiesHousingUnitsData = (state: RootState): ICountyWellWaterSystemResult[] => 
  state.wellWaterSystemAggregates.countiesHousingUnits || [];
const getZoomLevel = (state: RootState): string => state.wellWaterSystemAggregates.zoomLevel;
const getLoading = (state: RootState) => state.wellWaterSystemAggregates.loading;

export const selectRegionsHousingUnits = createSelector(
  [getRegionsHousingUnitsData],
  (data) => {
    return data.filter(Boolean).map(region => ({
      ...region,
      epaRegion: parseInt(region.epaRegion, 10).toString(),
      id: `region-${parseInt(region.epaRegion, 10)}`,
      hasHousingUnits: Boolean(region.totalHousingUnits)
    }));
  }
);
  
export const selectCountiesHousingUnits = createSelector(
  [getCountiesHousingUnitsData],
  (data) => {
    return data.filter(Boolean).map(county => ({
      ...county,
      id: `county-${county.county_name}`,
      hasHousingUnits: Boolean(county.totalHousingUnits)
    }));
  }
);

export const selectZoomLevel = createSelector(
  [getZoomLevel],
  (zoomLevel) => zoomLevel?.toLowerCase() || 'default'
);

export const WellWaterSystemsAggregatesSelector = {
  selectRegionsHousingUnits,
  selectCountiesHousingUnits,
  selectZoomLevel,
  getLoading,
};
